import { useSingleDriver } from "../../hooks/driver-operations/useDriverQueries";
import Loading from "../../components/shared/Loading";
import FavoriteButton from "./FavoriteButton";

function DriverModal({ id, type }) {
  // Get the driver data.
  const { driverData, loadingDriver, errorDriver } = useSingleDriver(id);

  // Show loading/Error state for queries.
  if (loadingDriver) return <Loading />;
  if (errorDriver) {
    return <h2>Error, something went wrong</h2>;
  }

  const { getDriver } = driverData;

  return (
    <div className="flex flex-col w-full">
      {/* Header */}
      <h3 className="text-white text-xl font-bold text-center mb-4">
        Driver Info
      </h3>

      {/* Driver Profile Card */}
      <div className="bg-white/5 border border-white/10 rounded-lg p-4 mb-3">
        {/* Profile Picture + Name Row */}
        <div className="flex items-center justify-center gap-3 mb-3 pb-3 border-b border-white/10">
          {getDriver.profilePicture ? (
            <img
              src={getDriver.profilePicture}
              alt={getDriver.name}
              className="h-16 w-16 rounded-full object-cover border-2 border-white/30"
            />
          ) : (
            <div className="h-16 w-16 rounded-full bg-main-green-light/30 flex items-center justify-center">
              <span className="text-white font-medium text-2xl">
                {getDriver.name?.charAt(0)?.toUpperCase() || "D"}
              </span>
            </div>
          )}
          <div className="text-center">
            <p className="text-white font-medium text-lg">{getDriver.name}</p>
            <p className="text-main-light-highlight/70 text-sm">{getDriver.phoneNumber}</p>
            <span
              className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium mt-1 ${
                getDriver.isOnDuty
                  ? "bg-green-100 text-green-800"
                  : "bg-gray-100 text-gray-600"
              }`}
            >
              <span
                className={`w-2 h-2 rounded-full mr-1.5 ${
                  getDriver.isOnDuty ? "bg-green-500" : "bg-gray-400"
                }`}
              />
              {getDriver.isOnDuty ? "Available" : "Offline"}
            </span>
          </div>
        </div>

        {/* Vehicle Info */}
        {(getDriver.carMake || getDriver.carModel || getDriver.carColor) && (
          <div className="grid grid-cols-2 gap-3 text-center mb-3 pb-3 border-b border-white/10">
            <div className="col-span-2">
              <p className="text-main-light-highlight/70 text-xs uppercase tracking-wide">
                Vehicle
              </p>
              <p className="text-white font-medium text-sm">
                {[getDriver.carColor, getDriver.carMake, getDriver.carModel]
                  .filter(Boolean)
                  .join(" ")}
              </p>
            </div>
            {getDriver.licensePlate && (
              <div className="col-span-2">
                <p className="text-main-light-highlight/70 text-xs uppercase tracking-wide">
                  License Plate
                </p>
                <p className="text-white font-medium text-sm">{getDriver.licensePlate}</p>
              </div>
            )}
          </div>
        )}

        {/* Stats */}
        <div className="grid grid-cols-2 gap-3 text-center">
          <div>
            <p className="text-main-light-highlight/70 text-xs uppercase tracking-wide">
              Completed Rides
            </p>
            <p className="text-white font-medium text-lg">
              {getDriver.completedRidesTotal || 0}
            </p>
          </div>
          <div>
            <p className="text-main-light-highlight/70 text-xs uppercase tracking-wide">
              Queue
            </p>
            <p className="text-white font-medium text-lg">
              {getDriver.riderQueue || 0} riders
            </p>
          </div>
        </div>
      </div>

      {/* Favorite Button */}
      <div className="flex justify-center">
        <FavoriteButton driverId={getDriver.id} size={28} showLabel />
      </div>
    </div>
  );
}

export default DriverModal;
